import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import colors from 'vuetify/lib/util/colors'
import es from 'vuetify/lib/locale/es'

Vue.use(Vuetify);

const vuetify = new Vuetify({
    theme: {
      themes: {
        light: {
          primary: colors.lightGreen.darken1,
          secondary:colors.brown.darken1,
          tertiary: colors.lightGreen.lighten5,
          accent: colors.shades.black,
          error: colors.red.darken2,
        },
        dark: {
          primary: colors.blue.darken3,
        },
      },
    },
    lang: {
      locales: {es},
      current: 'es',
    },
  })
export default vuetify
